module.exports = __webpack_public_path__ + "static/media/mobile-r.b0b1618f.png";